$(function () {
var scroll = 0;
var w = $(window).width();
var wh = $(window).height();
$(window).on('load scroll',function() {
  scroll = $(this).scrollTop();
});

// ハンバーガーメニュー
  if (w > 768) {
$(".nav_toggle").on({
  'mouseenter': function() {
    $('.nav_toggle, .main-nav').addClass('show');
  }
});
$(".main-nav").on({
  'mouseleave': function() {
    $('.nav_toggle, .main-nav').removeClass('show');
  }
});    
}
if (w < 769) {
  $('.nav_toggle').on('click', function () {
    $('.nav_toggle, .main-nav').toggleClass('show');
  });
}
$('.main-nav ul li a').on('click', function () {
  $('.nav_toggle, .main-nav').toggleClass('show');
});
  
$('.dropdown-btn').on('click',function(){
  var t = $(this).text();
  if(t == "＋" ){
    $(this).text("－");
  }else{
    $(this).text("＋");
  }
  $(this).parents('.nav-item').find('.dropdown-menu').slideToggle();
});

// モバイルフッターボタン
if (w < 769) {
  $(window).on('load scroll', function(){  
  var f = $('footer').offset().top;
    if(scroll > 100 && scroll < f - wh){
      $('.boost-pfs-filter-tree-mobile-button, .filters-outer').fadeIn(300,'linear');
    }else{
      $('.boost-pfs-filter-tree-mobile-button, .filters-outer').fadeOut(300,'linear');
    }
  });
}

//キャンペーンバナー
if (w < 769) {
  $('.follow-banner__inner').on('click', function () {
    $(this).closest('.follow-banner').toggleClass('show');
  });

  $('.follow-banner-close').on('click', function () {
    $(this).closest('.follow-banner').toggleClass('show');
  });
}

//  TOPのPCだけリンク
if (w > 768) {
  $('#top-product .product__list article, #top-packaging').on('click', function(){
    const href = $(this).find("a").attr("href");
    location.href = href;
  });
}
  
// 画面の高さを取得・設定
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--rvh', `${vh}px`);
}
setHeight();

$(window).on('resize', function(){
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--rvh', `${vh}px`);
});


// フィルターオープン
if(w > 768){
  $(".filter-open").on({
    'mouseenter': function() {
      $(this).next('.boost-pfs-filter-left-col').fadeIn(500);
      $('.filter-open').css('opacity',0);
    }
  })
  $(".boost-pfs-filter-left-col").on({
    'mouseleave': function() {
      $(this).fadeOut(500);
      $('.filter-open').css('opacity',1);
    }
  })  
  $('.boost-pfs-filter-left-col .filter-close').on('click',function(){
    $('.boost-pfs-filter-left-col').fadeOut(500);
    $('.filter-open').css('opacity',1);
  });
}

//SP並べ替え
if(w < 769){
  $('.filters-outer').on('click', function(){
    $(this).find('select').trigger('click');
  });
}

// フィルターメニュー
if(w > 768){
$(".filter-nav .drop-hover").on({
  'mouseenter': function() {
    $(this).find('.dropdown-menu').fadeIn(500);
  },
  'mouseleave': function() {
    $(this).find('.dropdown-menu').fadeOut(500);
  }
})
}else{
$(document).on('click','.filter-nav .drop-hover',function(){
  if(!$(this).parent('.nav-item').hasClass('open')){
    $('.nav-item').removeClass('open');
    $('.dropdown-menu').fadeOut(0);
    
    $(this).parent('.nav-item').addClass('open');
    $(this).find('.dropdown-menu').slideToggle();
  }else{
    $(this).parent('.nav-item').removeClass('open');
    $(this).find('.dropdown-menu').slideToggle();   
  }
});
}


// 商品詳細
//スライダー
var product_swiper = new Swiper('.product__media-list', {
  slidesPerView: 1,
  speed: 500,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    769: {
      pagination: false
    }
  }
});
  
//サムネイル
$('.product__media-thumbnail .product__media-thumbnail__item').on('click', function(){
  const index = $('.product__media-thumbnail .product__media-thumbnail__item').index($(this));
  product_swiper.slideTo(index + 1);
});


var current;
$(".color_variation ul li").on({
  'mouseenter': function() {
    current = $('.product__media-list .slick-active img').attr('src');
    var hover = $(this).find('img').attr('src');
    var hover = hover.replace('small','large');
    console.log(current);
    $('.product__media-list .slick-active img').attr('src', hover);
  },
  'mouseleave': function() {
    $('.product__media-list .slick-active img').attr('src', current);
  }
})

// おすすめ商品
  var ranking = 0;
  var recommend = 0;
  var ranking = 0;
  var recommend = 0;
  var rank_flag =false;
  var rcmd_flag =false;
  var rcmd_flag_1 =false;
  var rcmd_flag_2 =false;
  var rcmd_flag_3 =false;
  var rcmd_flag_4 =false;
  var rcmd_flag_5 =false;
  
  $(window).on('load scroll', function(){
  if($(".product-ranking-list").length && !rank_flag) {
    ranking = $(".product-ranking-list").get(0).offsetTop;
    if( scroll > ranking - wh){
      
      const ranking_swiper = new Swiper('.product-ranking-list', {
        slidesPerView: 2,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        pagination: {
          el: '#ranking .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '#ranking .swiper-button-next',
          prevEl: '#ranking .swiper-button-prev',
        },
        breakpoints: {
          769: {
            slidesPerView: 3,
            centeredSlides: false,
          }
        }
      });
        
      rank_flag = true;
    }
  }
    
  if($(".product-recommendations-list").length) {
    $(".product-recommendations-list").each(function(index){
      index = index +1;
      switch (index) {
  case 1:
    rcmd_flag = rcmd_flag_1;
    break;
  case 2:
    rcmd_flag = rcmd_flag_2;
    break;
  case 3:
    rcmd_flag = rcmd_flag_3;
    break;
  case 4:
    rcmd_flag = rcmd_flag_4;
    break;
 case 5:
    rcmd_flag = rcmd_flag_5;
    break;
}
      if(!rcmd_flag) {
      recommendations = $(this).get(0).offsetTop;
    if( scroll > recommendations - wh){
      var sliderSelector = $(this).find('.swiper-wrapper'); // スライダーのコンテナーとなる要素のセレクタ
      var slideItem = $(this).find('.swiper-slide');
      var slidable = slideItem.length > 3 ;
      
      const recommendations_swiper = new Swiper(this, {
        slidesPerView: 2,
        initialSlide: 0,
        loop: slidable,
        centeredSlides: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next'+index,
          prevEl: '.swiper-button-prev'+index,
        },
        breakpoints: {
          769: {
            slidesPerView: 3,
            centeredSlides: false
          }
        },
      });
      switch (index) {
        case 1:
          rcmd_flag_1　= true;
          break;
        case 2:
          rcmd_flag_2　= true;
          break;
        case 3:
          rcmd_flag_3　= true;
          break;
        case 4:
          rcmd_flag_4　= true;
          break;
        case 5:
          rcmd_flag_5　= true;
          break;
      }

    }
    }
    });
  }
});

// モーダルウィンドウの表示/非表示
$('.modal_btn').each(function () {
  $(this).on('click', function () {
    var target = $(this).data('target');
    var modal = document.getElementById(target);
    $(modal).fadeIn(300);
    return false;
  });
});

  // ウィンドウを閉じる
$('.js-modal-close, .crossーclose').on('click', function () {
  $('.js-modal').fadeOut(300);

  return false;
});

var href = location.href;
var search = location.search;
var filter_nav = $('.filter-nav');


if(w < 769){
      $('.filter-close.for-pc + .filter-nav').remove();
  setTimeout(function(){
    filter_nav.prependTo(".boost-pfs-filter-options-wrapper");
	},1200);
}

if(search.length > 1 ){
  $('.filter-off').css('display','none');
  $('.filter-on').css('display','block');
}
var optionText,result;

function filterTextChange(){
  $('.boost-pfs-filter-option-value').each(function(){
    optionText = $(this).text();
    if(optionText.indexOf('-') !== -1){
      result = optionText.replace("-", "〜");
      optionText = $(this).text(result);  
    }else if(optionText.indexOf('上') !== -1){
      result = optionText.replace("上", "");
      optionText = $(this).text(result+"〜");  
    }
  });
}
setTimeout(function(){
  filterTextChange();
}, 850);

  
function clearBtnShow(){
  var clear_flag = false;
  $('.boost-pfs-filter-clear').removeClass('show');
  $('.boost-pfs-filter-option-item-list.boost-pfs-filter-option-item-list-multiple-list li').each(function(){
   if($(this).hasClass('selected')){
     $('.boost-pfs-filter-tree-v .boost-pfs-filter-show-result').addClass('clear');
     $(this).parents('.boost-pfs-filter-option-content').prev('.boost-pfs-filter-option-title').find('.boost-pfs-filter-clear').addClass('show');
     clear_flag = true;
   }
  });
  if(!clear_flag){
    $('.boost-pfs-filter-tree-v .boost-pfs-filter-show-result').removeClass('clear');
  }
}
setTimeout(function(){
  clearBtnShow();
}, 850);

  
var observer = new MutationObserver(function(mutations) {
  if(href !== location.href) {
    search = location.search;
    href = location.href;
    if(search.length > 1 ){
      $('.filter-off').css('display','none');
      $('.filter-on').css('display','block');
    }else{
      $('.filter-on').css('display','none');
      $('.filter-off').css('display','block');
    }
    setTimeout(function(){
    filterTextChange();
      }, 700);
    if(w < 769){
      setTimeout(function(){
        clearBtnShow();
        filter_nav.prependTo(".boost-pfs-filter-options-wrapper");
      }, 500);
    }
  }
});

observer.observe(document, { childList: true, subtree: true });
});

$(document).on('click','.chakra-modal__body .chakra-button', function(){
  setTimeout(function(){
  $('.chakra-modal__body .chakra-text').each(function(e){
    console.log($(this).text());
    if($(this).text() == 'メッセージカード'){
      $(this).text('英訳栞');
    }
  });
    },1000);
});
// $(window).on('load', function(){
//   setTimeout(function(){
//    $('.chakra-text.css-133gj99').text("ギフト設定に進む");
//    // $('.css-1v621zr').css({'cssText': 'display: none !important;'});
//      $('.css-rdto6t').after("<p>※ギフト包装を希望しない場合はこのまま「ご購入手続きへ」にお進みください。</p>");
//      }, 1800);
// });

(function retryUpdate(count = 0) {
  const MAX_RETRY = 5;

  setTimeout(function () {
    const $target = $('.chakra-text.css-133gj99');
    const desiredText = 'ギフト設定に進む';

    if ($target.length === 0) {
      if (count < MAX_RETRY) retryUpdate(count + 1);
      return;
    }

    if ($target.text().trim() !== desiredText) {
      $target.text(desiredText);

      if ($('.gift-note').length === 0 && $('.css-rdto6t').length) {
        $('.css-rdto6t').after(
          '<p class="gift-note">※ギフト包装を希望しない場合はこのまま「ご購入手続きへ」にお進みください。</p>'
        );
      }

      if (count < MAX_RETRY) retryUpdate(count + 1);
    }
  }, 2000);
})();

$(document).on('change','.chakra-checkbox__input', function(){
  setTimeout(function(){
   $('.chakra-button.css-1xez722').text("ギフト設定はこちらから").css('width','190px');
    },500);
});

// 商品詳細
$(window).on('load', function(){
  var title = $('.product__title span');
  title.each(function(){
    var elem = $(this);
    if(elem.text().indexOf("作") >= 0){
	const elemTxt = elem.html();// 対象の文字列を取得
	const replaceTxt = elemTxt.replace(/作/g,'<span style="font-size:0.7em">作</span>');
	elem.html(replaceTxt);// 差し替え
    }
  });
  
  var list = $('.color_variation ul li');
  list.each(function(){
    var elem = $(this).find('.product__color');
    if(elem.text().indexOf("・") >= 0　&& elem.text().length > 10){
	const elemTxt = elem.html();// 対象の文字列を取得
	const replaceTxt = elemTxt.replace(/・/g,'・<br>');
	elem.html(replaceTxt);// 差し替え
    }
  });
});


$(document).on('change','.chakra-checkbox__input', function(){
  if ( $(this).prop('checked') ){
    $('.cart__note').css('display','none');
    $('.cart__footer').css('justify-content','flex-end');
  }else{
    $('.cart__note').css('display','block');
    $('.cart__footer').css('justify-content','space-between');
  }
});

$(window).on('load', function(e) {
  $("input[type='text'], input[type='email'], input[type='password'], input[type='tel'], input[type='search'],textarea").each(function(){
  var val = $(this).val();
  if(val){
    $(this).next('label').fadeOut(0);
  }
    });
});
$(document).on('keyup',"input[type='text'], input[type='email'], input[type='password'], input[type='tel'], input[type='search'],textarea", function(e) {
  var val = $(this).val();
  if(val){
    $(this).next('label').fadeOut(0);
  }else{
    $(this).next('label').fadeIn(0);
  }
});
